<template>
  <div class="myIssueLook">
    <div class="item">
      <div class="item_top">
        <div class="top_left van-multi-ellipsis--l2">
          简洁而又优雅的大理石设计，放在卫生间里真好看
        </div>
        <div class="top_right">
          <img src="../../assets/images/banner.jpg" />
        </div>
      </div>
      <div class="item_bottom">
        <div class="bottom_left">
          获客
          <span>2</span>
          人
        </div>
        <div class="bottom_right">2月18日</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MyIssueLook"
};
</script>

<style lang="scss" scoped>
.myIssueLook {
  .item {
    border-bottom: 0.02rem solid #f5f5f5;
    padding: 0.3rem 0.3rem 0.1rem 0.3rem;
    .item_top {
      display: flex;
      .top_left {
        width: calc(100% - 1.2rem);
        padding-right: 0.15rem;
        span {
          margin: 0 0.2rem;
        }
      }
      .top_right {
        width: 1.2rem;
        height: 0.8rem;
        border-radius: 0.05rem;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .item_bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 0.5rem;
      color: #999999;
      font-size: 0.24rem;
    }
  }
}
</style>
